<template>
  <create-dialog
    width="70%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-md-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.code')}: *`"
            v-model="model.code"
            name="common_words.code"
            v-validate="modelValidations.code"
            :error="getError('common_words.code', true)"
            placeholder=" ..."
            @click="handleClickOnCode()"
          >
          </fg-input>
        </div>
        <div class="col-12 col-md-8">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')} *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
        <div v-if="businesses.length > 2" class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.companies2') }} *</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.business_id', businesses)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.description') }}: </label>
            <br />
            <el-input
              maxlength="300"
              show-word-limit
              type="textarea"
              :rows="3"
              placeholder="..."
              v-model="model.description"
              class="shadow-sm"
            ></el-input>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-contract',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [MixinDialog, MixinForm, MixinPermissions, MixinValidations],
  data() {
    return {
      businesses: [],
      disabledField: false,
      model: {
        name: null,
        code: null,
        description: null,
        business_id: [],
        route: null,
      },
      modelValidations: {
        name: { required: true },
        code: { required: true },
      },
    };
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    handleOpen() {
      if (!this.model.isEdit) {
        this.model.business_id = this.selectElementsAsignFromModel(
          1,
          this.model.business_id,
          this.businesses
        );
      }
    },
    handleClickOnCode() {
      if (!isset(this.model.code) && !this.model.isEdit) {
        const tableCode = JSON.parse(sessionStorage.getItem('tableCode'));
        this.codeGenerator(i18n.t('labor.type_contracts'), tableCode);
      }
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else {
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const { id, name, code, description, businesses } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        id,
        name,
        code,
        description,
        business_id: businesses.map((business) => business.id),
        isEdit: true,
      };
      this.errors.clear();
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('businesses/only')])
        .then((response) => {
          const [response_businesses] = response;
          this.businesses = this.concatAll(response_businesses.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
